<template>

  <div class="member" data-tab-wrap>

    <section class="ttl-bg-color">
      <div class="ttl-bg-color__inner">
        <h1 class="ttl-bg-color__ttl">会員機能</h1>
      </div>
    </section>


    <nav class="tab is-two">
      <ul class="tab__list">
        <li class="tab__item">
          <span data-tab="simulation" class="tab__link">保存した<br class="sp">シミュレーション</span>
        </li>
        <li class="tab__item">
          <spaan data-tab="search" class="tab__link">過去に検索した<br class="sp">条件</spaan>
        </li>
      </ul>
    </nav>

    <section class="keep" data-tab-content="simulation">
      <div class="keep__inner">
        <div
            v-for="simulation in pageData.simulations"
            @click="link"
            :data-href="`/companies/${simulation.company_id}/simulation?job_type=${encodeURIComponent(simulation.job_type)}&education_level_id=${simulation.education_level_id}`"
            class="keep__item"
        >
          <span
              :data-id="simulation.simulation_id"
              @click.prevent.stop="deleteSimulation"
              class="close is-member"
          ></span>

          <div class="keep__top">
            <p class="keep__date">{{ simulation.simulation_datetime }}</p>
          </div>
          <div class="keep__middle">
            <h2 class="keep__company">{{ simulation.company_name }}</h2>
            <p class="keep__txt">
              初任給総支給額　
              {{ simulation.job_type }}：
              {{ simulation.education_level_name }}
              <span>{{ simulation.salary.toLocaleString() }}</span>
              円</p>
          </div>
          <div class="keep__bottom">
            <p class="keep__txt-b">
              ひと月の自由に使えるお金<br class="sp"><strong>{{
                simulation.disposable_income.toLocaleString()
              }}</strong><small class="">円</small>
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="keep" data-tab-content="search">
      <div class="keep__inner">

        <div
            v-for="search in pageData.search_conditions"
            @click="link"
            :data-href="getSearchUrl(search)"
            class="keep__item"
        >
          <span
              :data-id="search.search_id"
              @click.prevent.stop="deleteSearch"
              class="close is-member"
          ></span>
          <div class="keep__top">
            <p class="keep__date">{{ search.search_datetime }}</p>
          </div>
          <div class="keep__bottom">
            <div class="keep__wrap-s">
              <p class="keep__cate-ttl">検索条件</p>
              <div class="keep__wrap-cate">
                <p v-for="listing in search.listings" class="keep__cate">{{ listing }}</p>
                <p v-if="search.starting_salary_name" class="keep__cate">{{ search.starting_salary_name }}</p>
              </div>
            </div>
            <p class="keep__txt-m">{{ getSearchItems(search).join('／') }}</p>
          </div>
        </div>
      </div>
    </section>
    
  </div>
</template>
<script setup lang="ts">
import {usePageStore} from "../../stores/page";
import {NaviClient} from "../../api/NaviClient";
import {remove} from "es-toolkit";
import {onMounted} from "vue";

const pageDataStore = usePageStore();
const pageData = pageDataStore.pageData;


const link = e => {
  location.href = e.currentTarget.dataset.href
}

const getSearchItems = (search) => {
  let items = [];
  if (search.sub_industries) {
    items = items.concat(
        search.sub_industries.map((i) => {
          return i.sub_industry_name
        })
    )
  }
  if (search.prefectures) {
    items = items.concat(
        search.prefectures.map((i) => {
          return i.prefecture_name
        })
    )
  }
  if (search.search_text) {
    items.push(search.search_text);
  }
  return items;
}

const getSearchUrl = (search) => {
  let urlParams = new URLSearchParams();

  if (search.search_text) {
    urlParams.append(
        'search_text',
        search.search_text
    );
  }
  if (search.sub_industries) {
    search.sub_industries.forEach((i) => {
      urlParams.append(
          'sub_industry_id[]',
          i.sub_industry_id
      );
    });
  }
  if (search.prefectures) {
    search.prefectures.forEach((p) => {
      urlParams.append(
          'prefecture_id[]',
          p.prefecture_id
      );
    });
  }
  if (search.listings) {
    search.listings.forEach((l) => {
      urlParams.append(
          'listings[]',
          l
      );
    });
  }
  if (search.starting_salary) {
    urlParams.append(
        'starting_salary',
        search.starting_salary
    );
  }
  return `/?${urlParams.toString()}`
}

const deleteSimulation = (e) => {
  const simulation_id = e.target.dataset.id;
  NaviClient.simulationDelete(simulation_id).then((json) => {
    console.log(json);
  }).catch((error) => {
    console.log(error);
  })
  console.log('deleteSimulation');
  remove(pageData.simulations, (s: any) => {
    return s.simulation_id == simulation_id;
  });
};

const deleteSearch = (e) => {
  const search_id = e.target.dataset.id;
  NaviClient.searchDelete(search_id).then((json) => {
    console.log(json);
  }).catch((error) => {
    console.log(error);
  });
  console.log('deleteSearch');
  remove(pageData.search_conditions, (s: any) => {
    return s.search_id == search_id;
  });
};

</script>